import FingerprintJS from '@fingerprintjs/fingerprintjs';

// 设备指纹（FingerprintJS 开源版，MIT）。纯客户端计算，数据不出站；用于反盗版同设备识别。
// memoize：每次页面加载只算一次；localStorage 作快速回退（首个请求前指纹尚未算出时用）。
const KEY = 'zxdata.deviceFp';
let cached: string | null = null;
let pending: Promise<string | null> | null = null;

function readCache(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

function compute(): Promise<string | null> {
  if (pending) return pending;
  pending = (async () => {
    try {
      const agent = await FingerprintJS.load();
      const r = await agent.get();
      cached = r.visitorId;
      try {
        localStorage.setItem(KEY, cached);
      } catch {
        /* ignore */
      }
      return cached;
    } catch {
      cached = readCache();
      return cached;
    } finally {
      pending = null;
    }
  })();
  return pending;
}

// 取设备指纹：已算出则即时返回；否则等计算，但最多等 800ms（超时先用 localStorage 回退，后台继续算）。
// 任何失败都返回 null，绝不阻塞业务请求。
export function ensureDeviceFp(): Promise<string | null> {
  if (cached) return Promise.resolve(cached);
  const computed = compute();
  return Promise.race([
    computed,
    new Promise<string | null>((resolve) => {
      setTimeout(() => resolve(cached ?? readCache()), 800);
    }),
  ]);
}

// 同步快速取值（拦截器兜底用）。
export function getCachedFp(): string | null {
  return cached ?? readCache();
}
